/**
 * Phonics Letter Ww — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/ww/）
 * 开发环境通过 public/media/phonics/ww/ 访问，生产环境由 NGINX 提供
 *
 * 课程结构（10 PPT slides）：
 * - P1: 封面
 * - P2: Part 1 指引
 * - P3: Song/Chant (Ww.mp4, 00:12-01:38)
 * - P4: 4格单词 (wolf, watch, well, wagon)
 * - P5: 跟读视频 (同P3)
 * - P6: 跟读练习
 * - P7: Part 2 指引
 * - P8: Story 1 - video-left-vocab-right, 右上4单词+下边3句台词(有翻译)
 * - P9: Story 2 - video-top-lines-bottom, 3句台词(不要翻译)
 * - P10: Story 3 - video-top-lines-bottom, 3句台词(不要翻译)
 * - P11: Chant
 * - P12: Summary
 * - P13: Thank You
 */

const MEDIA_BASE = '/media/phonics/ww';

const letterDataWw = {
  letter: 'Ww',
  title: 'Phonics',
  subtitle: 'Letter Ww',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Ww.mp4`,
    poster: `${MEDIA_BASE}/Ww.png`,
    startTime: 12,
    endTime: 98,
  },

  // Step 2: 4格单词视频
  // 顺序: wolf(w1,image8), watch(w2,image9), well(w3,image10), wagon(w4,image11)
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4`, cover: `${MEDIA_BASE}/image8.png`,  word: 'wolf',  wordCn: '狼' },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4`, cover: `${MEDIA_BASE}/image9.png`,  word: 'watch', wordCn: '手表' },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4`, cover: `${MEDIA_BASE}/image10.png`, word: 'well',  wordCn: '水井' },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4`, cover: `${MEDIA_BASE}/image11.png`, word: 'wagon', wordCn: '马车' },
  ],

  // Story sections
  storySections: [

    // === Learn the Story (1) ===
    // 布局: 左视频 + 右上4单词 + 下边3句故事台词
    // PPT Slide 8: 右侧上方3单词(Mr./clean/Wonderful) + 3句故事台词
    // ⚠️ 右上方实际显示3个单词(wonderful已含在句中)，
    //    按splitAt:3布局，右侧放wonderful/Mr./clean
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      splitAt: 3,
      videos: [{ src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` }],
      lines: [
        // 右侧单词 (前3条 = 右上)
        { en: 'wonderful', cn: '太棒了', audioEn: `${MEDIA_BASE}/w_en_wonderful.mp3`, audioCn: `${MEDIA_BASE}/w_cn_wonderful.mp3` },
        { en: 'Mr.',        cn: '先生',   audioEn: `${MEDIA_BASE}/w_en_mr.mp3`,       audioCn: `${MEDIA_BASE}/w_cn_mr.mp3` },
        { en: 'clean',     cn: '清理',   audioEn: `${MEDIA_BASE}/w_en_clean.mp3`,    audioCn: `${MEDIA_BASE}/w_cn_clean.mp3` },
        // 下方故事台词 (剩余 = 下边)
        { en: 'Mr. Wolf, what are you doing?',  cn: '你在做什么？',         audioEn: `${MEDIA_BASE}/story1_en_1.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3` },
        { en: "I'm cleaning my watch.",          cn: '我在清理我的手表。',   audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: 'Wonderful! I like your watch!',  cn: '太棒了！我喜欢你的手表。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
      ],
    },

    // === Learn the Story (2) ===
    // 布局: 上视频 + 下台词(不要翻译)
    // PPT Slide 9: 无右侧单词，3句故事台词
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` }],
      lines: [
        { en: 'Mr. Wolf, what are you doing?',  audioEn: `${MEDIA_BASE}/story2_en_1.mp3` },
        { en: "I'm cleaning my well.",           audioEn: `${MEDIA_BASE}/story2_en_2.mp3` },
        { en: 'Wonderful! I like your well!',   audioEn: `${MEDIA_BASE}/story2_en_3.mp3` },
      ],
    },

    // === Learn the Story (3) ===
    // 布局: 上视频 + 下台词(不要翻译)
    // PPT Slide 10: 无右侧单词，3句故事台词
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_3.mp4`, poster: `${MEDIA_BASE}/image15.png` }],
      lines: [
        { en: 'Mr. Wolf, what are you doing?',  audioEn: `${MEDIA_BASE}/story3_en_1.mp3` },
        { en: "I'm cleaning my wagon.",          audioEn: `${MEDIA_BASE}/story3_en_2.mp3` },
        { en: 'Wonderful! I like your wagon!',  audioEn: `${MEDIA_BASE}/story3_en_3.mp3` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 封面页字母专属图
  coverPoster: `${MEDIA_BASE}/Ww.png`,
};

export default letterDataWw;
